import React from 'react';
import { FormNumber, Fieldset, FormSelect } from '~/components/FormControl';
import { Form, Col } from 'react-bootstrap';
import { COMPARED_OPTIONS } from '~/config/constants';

function DiceValue() {
    return (
        <Col sm={6}>
            <Fieldset>
                <Fieldset.Legend>DV:</Fieldset.Legend>
                <Form.Row>
                    <FormSelect
                        name={'dvCompareOption'}
                        options={COMPARED_OPTIONS || []}
                        sm={3}
                    />
                    <FormNumber
                        name={'dvCompareValue'}
                        sm={3}
                    />
                    <FormNumber
                        name={'dvAdded'}
                        sm={2}
                    />
                    <FormNumber
                        name={'dvDeducted'}
                        sm={2}
                    />
                    <FormNumber
                        name={'dvSet'}
                        sm={2}
                    />
                </Form.Row>
            </Fieldset>
        </Col>
    );
}

export default DiceValue;
